// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"435":"73aceef3a304dd80","2888":"1a13fca781175598"}[chunkId] + ".css";
};